<!-- Improved Class Card Component Template -->
<div *ngIf="userClass" class="class-card">
  
  <!-- Card Header/Body -->
  <div class="class-card__header">
    <h6 class="class-card__title">{{ userClass.title }}</h6>
    
    <img
      class="class-card__image"
      [src]="'assets/classes/class' + userClass.id + '.jpeg'"
      [alt]="'Class ' + userClass.id + ' image'"
      loading="lazy"
    />
    
    <p class="class-card__description">
      {{ userClass.description }}
    </p>
  </div>

  <!-- Card Footer with Activities -->
  <div class="class-card__footer">
    
    <!-- Progress Bar (optional - uncomment if needed) -->
    <!-- 
    <div *ngIf="userClassesTaken" class="progress-container">
      <div class="progress-bar">
        <div 
          class="progress-fill" 
          [style.width.%]="getPercentageVideoWatched()">
        </div>
      </div>
      <div class="progress-text">{{ getPercentageVideoWatchedText() }}</div>
    </div>
    -->
    
    <div class="class-card__activities">
      
      <!-- Video Activity -->
      <div 
        class="activity-row"
        (click)="get_video()"
        (keydown.enter)="get_video()"
        (keydown.space)="get_video()"
        tabindex="0"
        role="button"
        [attr.aria-label]="('CLASS_CARD.WATCH_CLASS' | translate) + ' ' + userClass.id"
        [attr.aria-disabled]="!canAccessVideo()">
        
        <div class="activity-row__content">
          <img
            class="activity-row__icon"
            src="assets/play1_blue.png"
            alt="Play video"
            aria-hidden="true"
          />
          <p class="activity-row__text">
            {{ 'CLASS_CARD.WATCH_CLASS' | translate }} {{ userClass.id }}
          </p>
        </div>
        
        <div class="activity-row__status">
          <img
            *ngIf="userClassesTaken"
            class="status-icon"
            [class.completed]="userClassesTaken.isVideoCompleted"
            [src]="userClassesTaken.isVideoCompleted ? 
                   'assets/checkmark-check.png' : 
                   'assets/checkmark-uncheck.png'"
            [alt]="userClassesTaken.isVideoCompleted ? 'Video completed' : 'Video not completed'"
          />
        </div>
      </div>

      <!-- Handout Activity -->
      <div 
        class="activity-row"
        (click)="get_handout()"
        (keydown.enter)="get_handout()"
        (keydown.space)="get_handout()"
        tabindex="0"
        role="button"
        [attr.aria-label]="('CLASS_CARD.STUDY_EBOOK' | translate) + ' ' + userClass.id"
        [attr.aria-disabled]="!canAccessHandout()">
        
        <div class="activity-row__content">
          <img
            class="activity-row__icon"
            src="assets/pdf_icon.png"
            alt="Download handout"
            aria-hidden="true"
          />
          <p class="activity-row__text">
            {{ 'CLASS_CARD.STUDY_EBOOK' | translate }} {{ userClass.id }}
          </p>
        </div>
        
        <div class="activity-row__status">
          <img
            *ngIf="userClassesTaken"
            class="status-icon"
            [class.completed]="userClassesTaken.isHandoutCompleted"
            [src]="userClassesTaken.isHandoutCompleted ? 
                   'assets/checkmark-check.png' : 
                   'assets/checkmark-uncheck.png'"
            [alt]="userClassesTaken.isHandoutCompleted ? 'Handout completed' : 'Handout not completed'"
          />
        </div>
      </div>

      <!-- Quiz Activity -->
      <div 
        class="activity-row"
        (click)="get_quiz()"
        (keydown.enter)="get_quiz()"
        (keydown.space)="get_quiz()"
        tabindex="0"
        role="button"
        [attr.aria-label]="('CLASS_CARD.QUIZ' | translate) + ' ' + userClass.id"
        [attr.aria-disabled]="!canAccessQuiz()">
        
        <div class="activity-row__content">
          <img
            class="activity-row__icon"
            src="assets/quiz1.png"
            alt="Take quiz"
            aria-hidden="true"
          />
          <p class="activity-row__text">
            {{ 'CLASS_CARD.QUIZ' | translate }} {{ userClass.id }}
          </p>
        </div>
        
        <div class="activity-row__status">
          <img
            *ngIf="userClassesTaken"
            class="status-icon"
            [class.completed]="userClassesTaken.isQuizCompleted"
            [src]="userClassesTaken.isQuizCompleted ? 
                   'assets/checkmark-check.png' : 
                   'assets/checkmark-uncheck.png'"
            [alt]="userClassesTaken.isQuizCompleted ? 'Quiz completed' : 'Quiz not completed'"
          />
        </div>
      </div>
      
    </div>
  </div>
</div>
